const styles = (theme) => ({
	inputMono: {
		fontFamily: "monospace",
		fontSize: "0.85rem",
		color: theme.palette.text.primary,
	},
	option: {
		display: "flex",
		alignItems: "center",
		justifyContent: "space-between",
		gap: 1,
	},
	optionTexts: {
		minWidth: 0,
	},
	optionKey: {
		fontFamily: "monospace",
		fontSize: "0.85rem",
		color: theme.palette.text.primary,
	},
	optionLabel: {
		fontSize: "0.72rem",
		color: theme.palette.text.secondary,
		lineHeight: 1.2,
	},
	globalIcon: {
		fontSize: "0.9rem",
		color: theme.palette.text.disabled,
	},
	chipAviso: {
		height: 16,
		fontSize: "0.6rem",
		// chip.main.arquive é o token real; background.arquive não existe
		bgcolor: theme.palette.chip.main.arquive,
		color: theme.palette.white.main,
	},
	editPaper: {
		p: 2,
		width: 340,
		display: "flex",
		flexDirection: "column",
		gap: 1.5,
	},
	editKey: {
		fontFamily: "monospace",
		fontSize: "0.9rem",
		fontWeight: 600,
		color: theme.palette.primary.main,
	},
	alertConflito: {
		fontSize: "0.75rem",
	},
	listaModelos: {
		pl: 2,
		my: 0.5,
		"& li": { fontSize: "0.7rem", lineHeight: 1.5 },
	},
});

export default styles;
